function newUtils() { }
newUtils.getFlushOdds = function (cards, obj) {
    const suits = {};
    cards.forEach(card => {
        const rank = card.slice(0, -1);
        const suit = card.slice(-1);
        if (!suits[suit]) suits[suit] = [];
        suits[suit].push(card);
    });

    const result = {};
    var allout = 52 - obj.allCards.length
    Object.keys(suits).forEach(suit => {
        if (suits[suit].length > 1) {
            const ranks = suits[suit].map(card => {
                const r = card.slice(0, -1);
                if (r === "A") return 14;
                if (r === "K") return 13;
                if (r === "Q") return 12;
                if (r === "J") return 11;
                if (r === "T") return 10;
                return parseInt(r);
            });
            const high = Math.max(...ranks);
            var all = obj.board_cards[0];


            var CardOddsOutFlush = all.filter((name) => name[1].includes(suit));





            var odds = flushProbabilityFlexible(obj.flushout[suit].out, allout, 5 - obj.board_cards[0].length, 3 - CardOddsOutFlush.length)
            result[suit] = {
                Card: suits[suit],
                high: high,
                odds: odds
            };
        }
    });

    return result;
};
newUtils.getPerOdds = function (cards, obj) {
    const suits = {};
    cards.forEach(card => {
        const rank = card.slice(0, -1);
        const suit = card.slice(-1);
        if (!suits[rank]) suits[rank] = [];
        suits[rank].push(card);
    });

    const result = {};
    var allout = 52 - obj.allCards.length
    Object.keys(suits).forEach(rank => {
        if (suits[rank].length > 1) {
            const ranks = suits[rank].map(card => {
                const r = card.slice(0, -1);
                if (r === "A") return 14;
                if (r === "K") return 13;
                if (r === "Q") return 12;
                if (r === "J") return 11;
                if (r === "T") return 10;
                return parseInt(r);
            });
            const high = Math.max(...ranks);





            try {
                var odds = pairProbabilityFlexible(obj.perout[rank].out, allout, 5 - obj.board_cards[0].length, 1)
                result[rank] = {
                    Card: suits[rank],
                    high: high,
                    odds: odds
                };
            } catch (error) {

            }

        }
    });

    return result;
};
newUtils.getHigh = function (card) {

    const r = card;
    if (r === "A") return 14;
    if (r === "K") return 13;
    if (r === "Q") return 12;
    if (r === "J") return 11;
    if (r === "T") return 10;
    return parseInt(r);

};
Array.prototype.diff = function (a) {
    return this.filter(function (i) { return a.indexOf(i) < 0; });
};
function factorial(n) {
    if (n === 0 || n === 1) return 1;
    let result = 1;
    for (let i = 2; i <= n; i++) result *= i;
    return result;
}

function combination(n, k) {
    if (k > n || k < 0) return 0;
    return factorial(n) / (factorial(k) * factorial(n - k));
}


function flushProbabilityFlexible(remainingSuitCards, remainingDeckCards, drawLeft, neededSuitCards) {
    if (neededSuitCards > drawLeft || remainingSuitCards < neededSuitCards) return 0;

    let totalCombos = combination(remainingDeckCards, drawLeft);
    let probability = 0;

    for (let i = neededSuitCards; i <= Math.min(remainingSuitCards, drawLeft); i++) {
        const suitComb = combination(remainingSuitCards, i); // i کارت هم‌خال
        const otherComb = combination(remainingDeckCards - remainingSuitCards, drawLeft - i); // بقیه کارت‌ها
        probability += (suitComb * otherComb) / totalCombos;
    }

    return parseFloat((probability * 100).toFixed(2));
}

function pairProbabilityFlexible(remainingRankCards, remainingDeckCards, drawLeft, neededSameRank) {
    if (neededSameRank > drawLeft || remainingRankCards < neededSameRank) return 0;

    let totalCombos = combination(remainingDeckCards, drawLeft);
    let probability = 0;

    for (let i = neededSameRank; i <= Math.min(remainingRankCards, drawLeft); i++) {
        const matchComb = combination(remainingRankCards, i); // i کارت هم‌rank
        const otherComb = combination(remainingDeckCards - remainingRankCards, drawLeft - i); // کارت‌های غیرمرتبط
        probability += (matchComb * otherComb) / totalCombos;
    }

    return parseFloat((probability * 100).toFixed(2));
}

newUtils.getOutInfoFlush = function (obj) {
    if (obj == null) {
        return {}
    }
    var cardsInfo = {};
    var cards = ["c", "s", "h", "d"];
    //console.log(obj);

    var all = obj.allCards.diff(obj.board_cards[0]);
    var canFlush = true;
    if (obj.state == 0) {
        canFlush = true
    }
    for (var i = 0; i < cards.length; i++) {

        var CardOddsOutFlush = all.filter((name) => name[1].includes(cards[i]));

        var _out = 13 - CardOddsOutFlush.length;

        // _out = parseInt((_out / allout) * 100);

        const ranks = CardOddsOutFlush.map(card => {
            const r = card.slice(0, -1);
            if (r === "A") return 14;
            if (r === "K") return 13;
            if (r === "Q") return 12;
            if (r === "J") return 11;
            if (r === "T") return 10;
            return parseInt(r);
        });
        //  console.log(ranks);

        const high = Math.max(...ranks);



        cardsInfo[cards[i]] = {
            card: cards[i],
            out: _out,
            nuts: 14,
            high: high,
            canFlush: canFlush
        };

    }
    var all = obj.board_cards[0];
    if (all.length > 0) {
        for (var i = 0; i < cards.length; i++) {

            var CardOddsOutFlush = all.filter((name) => name[1].includes(cards[i]));

            var nust = 14;

            const ranks = CardOddsOutFlush.map(card => {
                const r = card.slice(0, -1);
                if (r === "A") return 14;
                if (r === "K") return 13;
                if (r === "Q") return 12;
                if (r === "J") return 11;
                if (r === "T") return 10;
                return parseInt(r);
            });

            const high = Math.max(...ranks);
            const inputranks = ranks.sort(function (a, b) {
                return b - a;
            });
            // console.log(inputranks);

            for (var j = 0; j < inputranks.length; j++) {
                if (nust == inputranks[j]) {
                    nust = inputranks[j] - 1;
                }
            }
            var canFlush = false


            if (CardOddsOutFlush.length >= 3) {
                canFlush = true
            }
            if (CardOddsOutFlush.length >= 2 && all.length < 5) {
                canFlush = true
            }
            if (CardOddsOutFlush.length >= 1 && all.length == 3) {
                canFlush = true
            }

            cardsInfo[cards[i]].out = cardsInfo[cards[i]].out - CardOddsOutFlush.length
            cardsInfo[cards[i]].nuts = nust
            cardsInfo[cards[i]].canFlush = canFlush


        }
    }
    return cardsInfo;
};
newUtils.getOutInfoPer = function (obj) {
    if (obj == null) {
        return {}
    }
    var cardsInfo = {};
    var cards = ["2", "3", "4", "5", "6", "7", "8", "9", "T", "J", "Q", "K", "A"];
    //console.log(obj);

    var all = obj.allCards.diff(obj.board_cards[0]);

    for (var i = 0; i < cards.length; i++) {

        var CardOddsOutPer = all.filter((name) => name[0].includes(cards[i]));
        //var allout = 52 - (all.length + obj.board_cards[0].length);
        var _out = 4 - CardOddsOutPer.length;
        // _out = parseInt((_out / allout) * 100);



        if (CardOddsOutPer.length > 1) {
            if (newUtils.getHigh(cards[i]) < 10 && _out > 0) {
                _out = _out - 1;
            }
            cardsInfo[cards[i]] = {
                card: cards[i],
                out: _out,


            };
        }


    }

    var all = obj.board_cards[0];
    if (all.length > 0) {
        for (var i = 0; i < cards.length; i++) {

            var CardOddsOutFlush = all.filter((name) => name[0].includes(cards[i]));





            if (cardsInfo[cards[i]]) {
                cardsInfo[cards[i]].out = cardsInfo[cards[i]].out - CardOddsOutFlush.length
            }





        }
    }
    return cardsInfo;
};
newUtils.CleanOddsFlsuh = function (Seat, obj, key, Out) {
    //console.log("CleanOddsFlsuh", Seat, obj, key, Out);

    var result = true
    var High = Seat.flushOdds[key].high;
    if (Out.canFlush == true) {
        
        
        obj.map(p => {
            if (result == true) {
                var pHigh = 0;
                try {
                    pHigh = p.flushOdds[key].high;
                } catch (error) {
                }
                if (pHigh > High) {
                    result = false;
                }
            }
        });

    } else {
        result = false;
    }
    return result;
};

module.exports = newUtils;